import { Flex, rwd, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HeaderContainer = styled(Flex)`
  margin-bottom: ${Spacing.S16};

  ${rwd.equalOrLessThan('xlarge')} {
    min-height: 144px;
  }

  ${rwd.equalOrLessThan('medium')} {
    min-height: unset;
  }
`
